/**
 * App Component
 * Root application component
 */
import '@/styles/global.css';
import '@/styles/app-page.css';
import '@/styles/admin-sharp.css';
import '@/styles/data-components.css';
import '@/styles/instrumented-paper.css';
import { AppProviders } from './providers';

export function App() {
  return <AppProviders />;
}


